export default __webpack_public_path__ + "static/media/IMPERIUM-FINANCE.c99491d1.png";